import React, {useState} from 'react';
import {Card, CardBody, CardHeader} from "reactstrap";
import apiUser from "../../../apiUser";
import {Link, useHistory} from "react-router-dom";
import appUserRoutes from "../../../appUserRoutes";
import {getByModuleId, MODULE_RELAYS_FUSES} from "../Modules";
import LoadingSpinner from "../../LoadingSpinner/LoadingSpinner";
import ComponentsTypeIdSelect from "./ComponentsTypeIdSelect";
import useAfterUpdateEffect from "../../../utils/useAfterUpdateEffect";
import {useTecRmi} from "../../../contexts/TecRmiContext";
import TecRmiSvgHtml from "../TecRmiSvgHtml";
import useDidMountEffect from "../../../utils/useDidMountEffect";
import {isNil} from "lodash";
import ModuleCardList from "../ModuleCardList";

const RelaysFusesCard = props => {
  const { getApiPrimaryParams, ident } = useTecRmi()
  const history = useHistory();
  const [loading, setLoading] = useState(false)
  const [componentTypeId, setComponentTypeId] = useState()
  const [relaysFuses, setRelaysFuses] = useState([])
  const [boxOverviewHtml, setBoxOverviewHtml] = useState(null)

  useDidMountEffect(() => {
    window.clickOnElement_relaysFusesCard = (id) => {
      id = parseInt(id.match(/\d+/g).join(''))

      setRelaysFuses(relaysFuses => {
        setComponentTypeId(componentTypeId => {
          relaysFuses.forEach(relaysFuse => {
            relaysFuse.SubGroups.forEach(subGroup => {
              subGroup.ItemMps.forEach(itemMp => {
                if(itemMp.ItemMpId === id){
                  const par = [componentTypeId, relaysFuse.MainGroupId, subGroup.SubGroupId, itemMp.ItemMpId]

                  if(itemMp.BoxConfigurations.length === 1){
                    const boxConfiguration =itemMp.BoxConfigurations[0]
                    par.push(boxConfiguration.BoxConfigurationId)

                    if(boxConfiguration.BoxBuildPeriodQualCols.length === 1){
                      const boxBuildPeriodQualCol = boxConfiguration.BoxBuildPeriodQualCols[0]
                      par.push(boxBuildPeriodQualCol.QualColId)
                    }
                  }

                  history.push(appUserRoutes.tecRmi.tabModule(ident, getByModuleId(MODULE_RELAYS_FUSES, 'uriName'), par.join('/')))
                }
              })
            })
          })

          return componentTypeId
        })

        return relaysFuses
      })
    }
  })

  useAfterUpdateEffect(() => {
    if(isNil(componentTypeId)){
      return
    }
    setLoading(true)

    apiUser.tecRmi.relaysFuses.boxOverviewHtml({
      ...getApiPrimaryParams(),
      componentTypeId,
    })
      .then(res => setBoxOverviewHtml(res.data[0]))
      .then(() => setLoading(false))

    apiUser.tecRmi.relaysFuses.boxConfigurations({
      ...getApiPrimaryParams(),
      componentTypeId,
    })
      .then(res => setRelaysFuses(res.data))
      .then(() => setLoading(false))
  }, [componentTypeId])

  return (
    <Card className="h-100">
      <CardHeader className="p-1">
        <Link className="d-flex flex-row flex-nowrap align-items-center py-1" to={appUserRoutes.tecRmi.tabModule(ident, getByModuleId(MODULE_RELAYS_FUSES, 'uriName'), componentTypeId)}>
          <img src={getByModuleId(MODULE_RELAYS_FUSES, 'icon')} style={{ height: 24 }} />
          <span className="ml-1">{getByModuleId(MODULE_RELAYS_FUSES, 'name')}</span>
        </Link>
      </CardHeader>
      <CardBody className="overflow-hidden">
        <ComponentsTypeIdSelect
          onChange={setComponentTypeId}
        />

        {loading && <LoadingSpinner />}

        {
          boxOverviewHtml
            ? <TecRmiSvgHtml html={boxOverviewHtml} excludeJsFunctions={['clickOnElement']} renameFunctions={{ clickOnElement: 'clickOnElement_relaysFusesCard' }} />
            : <ModuleCardList items={relaysFuses.map((relaysFuse, key) => <Link to={appUserRoutes.tecRmi.tabModule(ident, getByModuleId(MODULE_RELAYS_FUSES, 'uriName'), [componentTypeId, relaysFuse.MainGroupId].join('/'))} key={key.toString()}>{relaysFuse.MainGroupName}</Link>)} />
        }
      </CardBody>
    </Card>
  );
};

export default RelaysFusesCard;